import { Plus, LogOut, Trash2, Volume2, VolumeX, X, Settings } from "lucide-react";
import { Switch } from "@/components/ui/switch";

export const Sidebar = ({
  conversations, activeId, user, autoSpeak, sidebarOpen,
  onNew, onOpen, onDelete, onToggleSpeak, onLogout, onClose, onOpenSettings,
}) => (
  <>
    <aside
      className={`fixed md:relative z-40 h-full w-72 md:w-80 border-r border-white/5 bg-slate-950/90 backdrop-blur-2xl flex flex-col transition-transform duration-300 ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
      }`}
      data-testid="sidebar"
    >
      <div className="p-5 border-b border-white/5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-cyan-400 shadow-[0_0_8px_#22d3ee] animate-pulse" />
          <span className="font-heading text-lg tracking-tight">KAI</span>
        </div>
        <button className="md:hidden text-slate-400" onClick={onClose}>
          <X className="w-5 h-5" />
        </button>
      </div>

      <button
        data-testid="new-conversation-btn"
        onClick={onNew}
        className="m-4 flex items-center gap-2 justify-center py-3 rounded-xl border border-cyan-500/30 text-cyan-300 hover:bg-cyan-500/10 hover:shadow-[0_0_15px_rgba(34,211,238,0.3)] transition-all text-sm font-medium"
      >
        <Plus className="w-4 h-4" /> Nueva conversación
      </button>

      <div className="flex-1 overflow-y-auto px-2">
        {conversations.length === 0 && (
          <p className="text-center text-slate-600 text-xs font-mono mt-6 px-4">
            Sin conversaciones registradas
          </p>
        )}
        {conversations.map((c) => (
          <div
            key={c.id}
            data-testid={`conversation-${c.id}`}
            onClick={() => onOpen(c.id)}
            className={`group flex items-center justify-between gap-2 px-3 py-3 rounded-lg cursor-pointer transition-colors mb-1 ${
              c.id === activeId ? "bg-cyan-500/10 border border-cyan-500/20" : "hover:bg-white/5 border border-transparent"
            }`}
          >
            <span className="truncate text-sm text-slate-300">{c.title || "Nueva conversación"}</span>
            <button
              data-testid={`delete-${c.id}`}
              onClick={(e) => onDelete(c.id, e)}
              className="opacity-0 group-hover:opacity-100 text-slate-500 hover:text-red-400 transition-all"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>

      <div className="p-4 border-t border-white/5">
        <button
          data-testid="settings-btn"
          onClick={onOpenSettings}
          className="w-full flex items-center gap-2 justify-center py-2.5 mb-3 rounded-xl border border-white/10 text-slate-300 hover:bg-white/5 hover:text-cyan-300 transition-all text-sm font-medium"
        >
          <Settings className="w-4 h-4" /> Personalizar
        </button>
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm text-slate-400 truncate">{user?.name || user?.email}</span>
          <button
            data-testid="logout-btn"
            onClick={onLogout}
            className="text-slate-500 hover:text-cyan-400 transition-colors"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
        <div className="flex items-center justify-between text-xs font-mono text-slate-400">
          <span className="flex items-center gap-1">
            {autoSpeak ? <Volume2 className="w-3.5 h-3.5" /> : <VolumeX className="w-3.5 h-3.5" />}
            Voz de Kai
          </span>
          <Switch
            data-testid="autospeak-toggle"
            checked={autoSpeak}
            onCheckedChange={onToggleSpeak}
          />
        </div>
      </div>
    </aside>

    {sidebarOpen && (
      <div className="fixed inset-0 z-30 bg-black/60 md:hidden" onClick={onClose} />
    )}
  </>
);
